/* eslint-disable no-case-declarations */
import { AIRBNB_ID, BOOKING_ID, EDOMIZIL_ID, ONLYAPARTMENTS_ID, TUI_ID } from 'constants/constants';
import React, { Component } from 'react';
import { formatFromString } from 'helpers/dates-helper';
import { gtmMicroconversions } from 'services/tracking/gtm/gtm-events';
import { logInline } from 'services/tracking/logger';
import PropTypes from 'prop-types';
import SnippetAd from 'molecules/snippet-ad';


export default class SnippetAdContainer extends Component {
  constructor(props) {
    super(props);
    this.version = null;
  }

  componentDidMount() {
    this.sendMicroconversion('inline-impression');
  }

  shouldComponentUpdate(nextProps) {
    const { ad } = this.props;
    return JSON.stringify(nextProps.ad) !== JSON.stringify(ad);
  }

  getImage(ad) {
    const random = Math.random();
    switch (ad.id) {
      case String(AIRBNB_ID):
        this.version = random > 0.5 ? 'A' : 'B';
        return random > 0.5 ? 'https://static.100r.systems/img/inline-ads/airbnb-inline-1.jpg' : 'https://static.100r.systems/img/inline-ads/airbnb-inline-2.jpg';
      case String(BOOKING_ID):
        return random > 0.5 ? 'https://static.100r.systems/img/inline-ads/booking-inline-1.jpg' : 'https://static.100r.systems/img/inline-ads/booking-inline-2.jpg';
      default:
        return `https://static.100r.systems/img/inline-ads/${ad.name}-inline.jpg`;
    }
  }

  getTitle(ad, t) {
    const { data: { name } } = this.props;
    const destination = name.split(', ')[0];
    switch (ad.id) {
      case String(AIRBNB_ID):
        return t('Feel at home in {destination}', { destination });
      case String(ONLYAPARTMENTS_ID):
        return t('Genießen Sie Ihren Aufenthalt in {destination}', { destination });
      case String(EDOMIZIL_ID):
        return destination.length > 25 ? t('Traumhafte Ferienunterkünfte buchen') : t('Traumhafte Ferienunterkünfte in {destination}', { destination });
      case String(TUI_ID):
        return destination;
      case String(BOOKING_ID):
        return `Casas y alojamientos únicos en ${destination}`;
      default:
        return '';
    }
  }

  getSubtitle(ad, t) {
    const { data: { name } } = this.props;
    const destination = name.split(', ')[0];
    switch (ad.id) {
      case String(AIRBNB_ID):
        return t('Live like a local, find unique places to stay');
      case String(ONLYAPARTMENTS_ID):
        return t('Ihre ideale Wohnung zum besten Preis');
      case String(EDOMIZIL_ID):
        return t('Finden Sie Ihr Zuhause für den nächsten Urlaub auf e-domizil');
      case String(TUI_ID):
        return t('Finde hier dein Ferienhaus zum Wohlfühlen.');
      case String(BOOKING_ID):
        return `Elige entre miles de opciones en ${destination}`;
      default:
        return '';
    }
  }

  getClickout(ad) {
    switch (ad.id) {
      default:
        return ad.clickout;
    }
  }

  sendMicroconversion(type) {
    const { data: { name: destination, guestsNumber, dateArrival, dateLeaving }, ad: { name: partnerName } } = this.props;
    const arrival = formatFromString(dateArrival, 'DD-MM-YYYY');
    const leaving = formatFromString(dateLeaving, 'DD-MM-YYYY');

    gtmMicroconversions(type, `${partnerName}/${destination}/${guestsNumber}/${arrival}_${leaving}`);
  }

  handleClick() {
    const { ad, position, handleClick } = this.props;
    this.sendMicroconversion('inline-click');
    logInline(position, ad.id, ad.transactionId);
    const clickUrl = this.getClickout(ad);
    window.open(clickUrl, '_self');
    handleClick();
  }

  render() {
    const { ad, isSerp, t } = this.props;

    if (!ad) return null;

    return (
      <SnippetAd
        color={ ad.color }
        handleClick={ this.handleClick.bind(this) }
        image={ this.getImage(ad) }
        isSerp={ isSerp }
        name={ ad.name }
        subtitle={ this.getSubtitle(ad, t) }
        t={ t }
        title={ this.getTitle(ad, t) }
      />
    );
  }
}

SnippetAdContainer.defaultProps = {
  ad: null,
  isSerp: true,
};

SnippetAdContainer.propTypes = {
  ad: PropTypes.shape({
    clickout: PropTypes.string,
    color: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.string,
    logo: PropTypes.string,
    transactionId: PropTypes.string,
  }),
  data: PropTypes.shape({
    dateArrival: PropTypes.number,
    dateLeaving: PropTypes.number,
    guestsNumber: PropTypes.number,
    name: PropTypes.string,
    rentalia_id: PropTypes.string,
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
  isSerp: PropTypes.bool,
  position: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};
